export enum ComponentId {
  IS_WITNESSES_DATA_AVAILABLE = "isWitnessesDataAvailable",
  PERSONS = "persons",
}
